"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpectedError = void 0;
const common_1 = require("../common");
class UnexpectedError extends common_1.AuthError {
    constructor(unexpectedError) {
        super(unexpectedError.message);
        this.inner = unexpectedError;
    }
}
exports.UnexpectedError = UnexpectedError;
//# sourceMappingURL=UnexpectedError.js.map